import { render, staticRenderFns } from "./SurveyQuestions.vue?vue&type=template&id=18d3e0f2&scoped=true"
import script from "./SurveyQuestions.vue?vue&type=script&lang=ts"
export * from "./SurveyQuestions.vue?vue&type=script&lang=ts"
import style0 from "./SurveyQuestions.vue?vue&type=style&index=0&id=18d3e0f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d3e0f2",
  null
  
)

export default component.exports